<div
  [id]="'system-notification-' + id"
  role="alert"
  [attr.aria-labelledby]="'system-notification-heading-' + id"
  class="system-notification__container flex flex--col u--1/1 system-notification__container--multi-line"
  [ngClass]="['system-notification__container--' + type, 'system-notification__size-' + size]"
  [class.system-notification__container--multi-line]="multiLineLayout"
  [class.system-notification__container--single-line]="!multiLineLayout"
  [class.sucessOverride]="type === 'success' && backgroundOverride"
  [class.systemNotificationContainerOverride]="backgroundOverride"
>
  <div class="system-notification__maincontent flex--item--zero">
    <div class="system-notification__heading flex">
      <div class="system-notification__icon" *ngIf="spinnerIcon === 'false'">
        <svg-icon
          [name]="icon"
          [svgStyle]="{ 'width.px': iconSize, 'height.px': iconSize, fill: iconColor }"
          [ngStyle]="{ height: iconSize + 'px', width: iconSize + 'px' }"
        >
        </svg-icon>
      </div>
      <div class="system-notification__icon u-pb--" *ngIf="spinnerIcon === 'true'">
        <wfm-spinner [show]="true" [size]="iconSize"></wfm-spinner>
      </div>

      <div
        aria-level="2"
        [id]="'system-notification-heading-' + id"
        role="heading"
        class="system-notification__heading-text"
      >
        {{ headingText }}
      </div>

      <div
        class="system-notification__heading-utilities"
        #headingUtilities
        [hidden]="hideHeaderUtility || headingUtilities.children.length === 0"
      >
        <ng-content select="[slot=heading-utilities]"></ng-content>
      </div>
    </div>
    <div class="system-notification__content" [class.u-pr0]="hideHeaderUtility && multiLineLayout">
      <p class="text-16 u-mv0" *ngIf="descriptionText">{{ descriptionText }}</p>
      <p
        class="system-notification__content--secondary-text text-14 u-mt0 u-mb0"
        #secondaryText
        [hidden]="secondaryText.children.length === 0"
      >
        <ng-content select="[slot=secondary-text]"></ng-content>
      </p>
    </div>

    <div class="demo__footer-utility" #descriptionUtilities [hidden]="descriptionUtilities.children.length === 0">
      <ng-content select="[slot=description-utilities]"></ng-content>
    </div>
  </div>
  <div [style.height.px]="iconSize">
    <button
      aria-controls="system-notification"
      aria-pressed="false"
      type="button"
      aria-label="Dismiss this system notification"
      class="button--icon button button--icon-transparent u-ml---- u-p0 flex__item--top"
      *ngIf="!hideCloseButton"
      (click)="close.emit()"
    >
      <div *ngIf="iconSize >= 24" class="system-notification__close-icon">
        <svg-icon
          name="ico-close-16"
          [svgStyle]="{ 'width.px': 16, 'height.px': 16, fill: 'currentColor' }"
          [ngStyle]="{ height: '16px' }"
        >
        </svg-icon>
      </div>
      <div *ngIf="iconSize === 12" class="system-notification__close-icon">
        <svg-icon
          name="ico-close-16"
          [svgStyle]="{ 'width.px': 12, 'height.px': 12, fill: 'currentColor' }"
          [ngStyle]="{ height: '12px' }"
        >
        </svg-icon>
      </div>
    </button>
  </div>
</div>
